import React from 'react'
import { ThemeProvider, Typography, CssBaseline} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import {theme} from '../theme.js'
import { TopBar } from '../components/TopBar/TopBar'
import {Footer} from '../components/Footer/Footer'
import {ControlledAccordions} from '../components/Accordion/Accordion'
import faq from '../images/faq (copy).jpg'
import tiling from '../images/blue-tile.png'
export const FAQ = () => {
  return (
    
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <Grid container spacing={0} style={{backgroundImage:`url(${tiling})`, backgroundAttachment:"fixed"}}>
        <Grid item xs={12}>
          <TopBar/>
        </Grid>
        <Grid item xs={12} style={{position: "relative"}}>
          <img src={faq} alt="FAQ" style={{width:"100%", height:"100%",}}/>
          <Typography variant="h1" style={{position:"absolute", color:"white", bottom:"0px", left:"50%", transform:"translate(-50%)"}}>FAQ</Typography>
        </Grid> 
        <Grid item xs={12}>
          <ControlledAccordions/>
        </Grid>
      <Footer/>
      </Grid>
    </ThemeProvider>
    )
}
